import { extractFromFile, type ExtractedSource } from './extractText';
import { detectBank } from './detectBank';
import { parseCapitec } from './capitec';
import { parseTymeBank } from './tymebank';
import { parseGenericCsv } from './genericCsv';
import type { ParsedStatement } from './types';

export type { ParsedStatement, Transaction } from './types';

export async function parseFile(file: File): Promise<ParsedStatement> {
  const src = await extractFromFile(file);
  return parseExtracted(src);
}

export function parseExtracted(src: ExtractedSource): ParsedStatement {
  if (src.kind === 'csv') {
    return parseGenericCsv(src.rows);
  }
  const bank = detectBank(src.text);
  if (bank === 'capitec')  return parseCapitec(src.text);
  if (bank === 'tymebank') return parseTymeBank(src.text);
  // Unknown bank with text — try Capitec layout (most common SA bank)
  const capitec = parseCapitec(src.text);
  if (capitec.transactions.length > 0) {
    capitec.warnings.unshift('Bank not detected by header — attempted Capitec layout.');
    return capitec;
  }
  return {
    bank: 'unknown',
    account: null,
    openingBalance: null,
    closingBalance: null,
    transactions: [],
    warnings: ['Could not detect bank and no rows parsed. Check the file format.'],
    balanceMismatches: [],
  };
}
